import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as Translations from '../../../../providers/i18n';

import * as GroupsSelectors from '../../../../selectors/groups';
import * as CurrentsSelectors from '../../../../selectors/current';
import getGroupNameByType from '../../getGroupNameByType';

function GroupTabItem({ groupId, groupName, onClick, currentGroupId }) {
    return (
        <button className={classNames('tab', { selected: currentGroupId === groupId })}
            onClick={() => onClick(groupId)}>
            {groupName}
        </button>
    );
}

GroupTabItem.propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    type: PropTypes.string,
    currentGroupId: PropTypes.string.isRequired,
    groupId: PropTypes.string,
    groupName: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state, ownProps) => {
    const { type, i18n } = ownProps;

    return {
        currentGroupId: CurrentsSelectors.getCurrentGroupId(state),
        groupId: GroupsSelectors.getGroupIdByType(state, type),
        groupName: getGroupNameByType(type, i18n)
    };
};

export default compose(
    Translations.connect,
    connect(mapStateToProps, {}))(GroupTabItem);
